export const DisplayMode = {
    GRID: 'grid',
    LIST: 'list',
    NONE: 'none'
};

export const CardStyles = {
    TINY: 'tiny',
    SMALL: 'small',
    MEDIUM: 'medium',
    FULL: 'full'
};

export const SliderMarks = {
    12: CardStyles.TINY,
    38: CardStyles.SMALL,
    64: CardStyles.MEDIUM,
    98: CardStyles.FULL
};

export const SliderMarksArray = [12, 38, 64, 98];



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/posts_controls_row/controls_helper.js